import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-01-22'
        tag='Poshmark'
        title='Poshmark Guide 2022: Welcome the new year with more sales!'
      >
        <p>
          A new year means new opportunities. It is high time you venture into what's popular and can bring you profit
          without leaving the comforts of your home, like online selling. Over the years, selling on online marketplaces
          has taken off uncontrollably. Now, it is your turn to discover what online selling can do for you.
        </p>
        <p>
          There are different online platforms where you can sell just about anything you like. Most of these
          marketplaces nowadays offer anything, but mostly, they have something to do with fashion pieces such as
          clothing, shoes, bags, accessories, and many more. But of course, items that you can find online aren't
          limited to that. You can also find electronics, pet items, home items, outdoor gear, basically anything that
          you can think of except those legally prohibited.{' '}
        </p>
        <p>
          One of the most in-demand platforms in the world of online selling is Poshmark (access it through their
          website poshmark.com or download the app). Like other platforms such as Mercari, Tradesy, Depop, eBay, and
          more, Poshmark is composed of millions of users across the United States and Canada. It is a social platform
          composed of buyers and sellers that share one goal; to earn and shop at the comforts of their home and find
          the best deals there are.{' '}
        </p>
        <p>
          As a seller, it is only fitting that you know the tough competition on shopping apps like Poshmark. With so
          many sellers like you, it can be overwhelming to think about how you can earn despite many sellers offering
          the exact item as yours. But don't worry, every seller experience the anxiety of thinking about the what-ifs
          and the negative thoughts of competing with others. To help, we have listed some tips and tricks on navigating
          through Poshmark this 2022, so you can earn by selling online and have a successful closet.
        </p>

        <h3>Listing Your Item</h3>
        <p>
          The first thing you need to keep in mind when listing on Poshmark is that it is free. So, list as much as you
          want, as many as you can! It doesn't matter whether you are selling a brand new or a used item. As long as
          they are still in good condition, you may list them and make money out of them. However, note that you have to
          be strategic when listing your item so you'll have a higher chance of attracting potential buyers to your
          listing. There are four sections that you have to pay attention to if you want a successful listing:
        </p>
        <p>
          <strong>Title:</strong> The title of your item is your frontline. The specific your listing title is, the more
          it will be easier to find for your buyers and the more it will be visible in search engine results. Don't
          forget to always include the brand of the item, category, sub-category, style name, target market, color, and
          the material used. That will help your listing appear when poshers search for a specific item on the platform.
        </p>
        <p>
          <strong>Photos:</strong> Note that your item photos and cover photo matter. Your photos are your selling point
          that gives your potential buyer the visual experience. When uploading your item's photos on Poshmark, keep in
          mind that it should be a square photo and has a clear background. In addition to this, the photo should also
          be well lit and shows multiple areas of the item. If the item you are selling has flaws, it is also essential
          to show them in the picture to set your buyer's expectations.
        </p>
        <p>
          <strong>Description:</strong> Your item description greatly influences your buyer's purchase decision. The
          more detailed the description is, the more it tends to sell. When describing your item, you may include the
          details in your title. Essential details such as the size, manual measurements, retail price (if the
          information is available), the item's condition (if it is BNT or used), and other descriptors that can help
          you persuade your potential buyer.
        </p>
        <p>
          <strong>Pricing:</strong> When deciding on the price of your listing, you must do your research. You may check
          others' listing prices to know how much such an item sells so you can compete with them. It is also crucial
          that you consider all the fees that may apply. Don't forget to provide a wiggle room on your price so your
          earnings won't be compromised when someone sends an offer.
        </p>

        <h3>Features To Boost Sales</h3>
        <p>
          <strong>Share:</strong> On Poshmark, sharing is life! The more you share, the more potential buyers see your
          listing, which will ultimately help you make more conversions. There are three kinds of sharing that you can
          do on the platform:
        </p>
        <ul>
          <li>
            <strong>Self Shares</strong> where you share your listings to make them appear on your followers' feed and
            at the top of search results.{' '}
          </li>
          <li>
            <strong>Community Shares</strong> wherein you can share others' listings to show some love and build
            connections. This kind of sharing can grow your followers and sales.{' '}
          </li>
          <li>
            <strong>Posh Party Shares</strong> where you share your listing on ongoing Posh parties where you get the
            chance to expose your listing in front of a big audience that shares the same interest depending on the
            party's theme.
          </li>
        </ul>
        <p>
          <strong>Follow:</strong> Growing your Poshmark account is closely similar to other social media platforms. On
          here, you can follow other closets and users that interest you. And because Poshmark has a social community
          that helps one another, following someone means earning a follow back as poshers usually return a favor. This
          is also another way of building your connections that can help you boost your sales, as this will help you
          come across the right buyer for your listings.
        </p>
        <p>
          <strong>Like:</strong> Like others' listing so you can earn a like back. Because Poshmark is a social
          marketplace, liking other listings can also help you grow your account. This is another way of building
          connections with other users. Always remember that on Poshmark, sellers can also turn into buyers. Keep on
          liking, and who knows, you might come across a seller that will like and buy your item.
        </p>
        <p>
          <strong>Offer to Likers:</strong> This feature helps you persuade those poshers who like your listings. It
          lets you send them an offer with at least a 10% discount along with a shipping discount. Note, though, that
          your offers expire in 24 hours.{' '}
        </p>
        <p>
          <strong>Bundles:</strong> This unique feature lets sellers like you reach out to your potential buyers with a
          group of items in your closet at a discounted price. Sending a bundle to your potential buyer offers a reduced
          shipping fee along with a discount on multiple items. Not only does this make your items move fast, but it
          will also help you dodge paying the shipping cost for each item.
        </p>
        <p>
          You may also maximize the use of other listings features to help you reach a broader audience, boost your
          sales, and grow your business. This include:
        </p>
        <p>
          <strong>Listing Videos:</strong> Including an additional visual experience for your potential buyers is a
          great advantage. Using this feature will let you bring your listings to life to showcase your item. You can
          post a video of how your buyers can style the item and show the details in motion. Uploading a video will
          automatically appear in your Posh Stories. To do this:
        </p>
        <ol>
          <li> Choose a listing</li>
          <li>
            {' '}
            Click <em>Edit then Add Photo & Video</em>
          </li>
          <li> Upload your pre-filmed clip or record one on the spot</li>
        </ol>
        <p>
          <strong>Style Tags:</strong> Like how it works on social media, hashtags on your listing will make them more
          discoverable. Using Style Tags makes it easy for your potential buyers to see and discover your listing when
          they search for specific detail about an item. This may include the brand name, the material used, color, and
          many other descriptors that can make your item stand out. To add style tags:
        </p>
        <ol>
          <li>Choose a listing in your closet</li>
          <li>Click on Edit</li>
          <li>Select Style Tags</li>
          <li>Add a tag using your own descriptor or use Poshmark's pre-populated tags</li>
        </ol>
        <p>
          <strong>Seller Discounted Shipping:</strong> This feature lets you put a discount on your listing visible to
          your potential buyers. Putting a discount is one of the best strategies to reel in customers, which can
          influence your sales volume. To do this, simply add a discount to your item while creating or editing a
          listing.{' '}
        </p>
        <p>
          <strong>Price Suggester:</strong> This feature allows you to have a price reference derived from other
          competitors on the platform with sold listings similar to yours. This is a great tool that lets you save time
          deciding on your listing price without compromising your profit. To do this, start by filling in your item
          title, category, and original price. Then Poshmark will automatically populate a price range for you.
        </p>

        <h3>Become a Posh Affiliate</h3>
        <p>
          If you wonder if there are any special rewards and access sellers can get on Poshmark, the answer is yes.
          Poshmark has launched a rewards program for its users. However, to get your hands on these rewards (redeemable
          credit), you will have to become a social media influencer or a Posh Ambassador. This program is called Posh
          Affiliate.
        </p>
        <p>
          Becoming a Posh Affiliate means you get the chance to join fun campaigns that are not only helpful in
          promoting your closet and making sales but also let you earn extra from Poshmark itself. This program benefits
          the platform with the help of sellers like you spreading the word about it.{' '}
        </p>
        <p>To join, you can be either of the two:</p>
        <ul>
          <li>
            <strong>Social media influencer</strong> with more than 5,000 followers on platforms like Twitter, YouTube,
            or Instagram and has one or more social media account linked to Poshmark.
          </li>
          <li>
            <p>
              <strong>Poshmark Ambassador</strong> who is in good standing with Poshmark. They are the ones who
              represent the community and know the workarounds about the platform. To become a Posh Ambassador, you have
              to accomplish specific criteria such as:
            </p>
            <ol>
              <li> 5,000 Self-Shares </li>
              <li> 5,000 Community Shares </li>
              <li> Have 50 Available listings</li>
              <li> Have sold 15 listings</li>
              <li> Acquire an average rating of (at least) 4.5</li>
              <li> Have an average ship time of less than three days </li>
              <li> Have left at least one love note for another Poshmark seller</li>
            </ol>
          </li>
        </ul>
        <p>
          You may track your progress by checking your account's <em>My Posh Stats</em> section. Head to{' '}
          <em>Account Tab, then to My Posh Status</em>, and you will see the Posh Ambassador Activity that will show you
          the list of criteria you have to accomplish. After you have accomplished the criteria, an invitation to become
          a Posh Ambassador will be sent to you. To qualify in the Posh Affiliate program as a Posh Ambassador, don't
          forget to link your social media account to your Posh account.
        </p>

        <h3>The Campaign</h3>
        <p>
          Once you are qualified to join, Poshmark determines the campaign you can participate in. You don't have to
          worry about where to check them, as a notification will be sent to you if you are eligible.{' '}
        </p>
        <p>
          You may see and manage your campaign by going to your{' '}
          <em>Account Tab, then My Seller Tools, then My Campaigns</em>. Note that every affiliate can only participate
          in one campaign every 14 days.{' '}
        </p>
        <p>
          Make sure to use the custom tracking link that you can find on your active campaign so Poshmark track your
          campaign performance. After this, you may complete your campaign by submitting the URL to your social media
          post to get paid. To do this:
        </p>
        <ol>
          <li> Once your campaign is live, copy the post URL.</li>
          <li>
            {' '}
            Go to <em>My Campaigns</em>.
          </li>
          <li> Select the campaign.</li>
          <li> Paste the link under your post and tap submit.</li>
        </ol>
        <p>
          Viola! Not only were you able to promote Poshmark, but you also earned extra by participating in such fun
          campaigns.{' '}
        </p>

        <h3>Poshmark Fees</h3>
        <p>
          As with any other marketplace, fees are always a part of selling. On Poshmark, their fees are straightforward
          for its users' convenience. Here's what to expect when you sell on Poshmark:
        </p>
        <ul>
          <li>
            <p>
              <strong>Commission Fees:</strong>
            </p>
            <ul>
              <li>
                <strong>$2.95 fee:</strong> This flat rate applies to all sales under $15.
              </li>
              <li>
                <strong>20% commission:</strong> For every item, you sell priced above $15, 80% of the sale goes to you
                and the 20% to the platform.{' '}
              </li>
            </ul>
            <p>
              Once the order is delivered and received by the buyer, your earnings automatically get credited to you.
              You have the option to spend it on Poshmark or withdraw it as cash.
            </p>
            <p>
              While the 20% may look pricey compared to other 0platform's commission rate, note that Poshmark is paying
              all the transaction fees on your behalf. This includes the credit card fees, pre-paid and pre-addressed
              shipping labels, and the maintenance of the platform, so they can provide the best customer service and
              keep the platform up and running.
            </p>
          </li>
          <li>
            <p>
              <strong>Shipping Fee:</strong>
            </p>
            <p>
              Poshmark's shipping fee is a flat rate of $7.45. This expedited shipping via USPS covers any order that
              does not exceed 5 lbs. If the weight of your package exceeds the 5 lbs. allowance, you should upgrade the
              shipping label accordingly.{' '}
            </p>
            <p>To do this in the app:</p>
            <ol>
              <li>Go to your Account, click on your @username</li>
              <li>Tap on My Sales and choose the relevant order</li>
              <li>Tap Need New Shipping Label</li>
              <li>Choose Need Heavier Weight Label</li>
            </ol>
            <p>If you are on the website:</p>
            <ol>
              <li>Click on your profile picture at the top right of the page</li>
              <li>Click My Sales and select the relevant order</li>
              <li>Click New Shipping Label</li>
              <li>Choose Need Heavier Weight Label on the dropdown menu</li>
            </ol>
          </li>
        </ul>

        <h3>Using Bots on Poshmark</h3>
        <p>
          While the Poshmark community guideline mentioned that sellers should not use programs or other forms of
          automation to participate on Poshmark, the provision has an exception. Poshmark is a fair platform, and the
          guideline not advising the use of automation software is so everyone can have equal opportunity on the
          platform regardless of whether they have big or small closets.{' '}
        </p>
        <p>
          Poshmark's algorithm favors those listings that are newly shared. That is why, if you want your listing to
          appear on top of the search results, sellers are encouraged to share actively to give their items a chance to
          be seen by potential buyers. This rule applies to all sellers regardless of the size of their closet.{' '}
        </p>
        <p>
          When a seller uses a bot, it gives them the advantage to share many times more than what an actual human can
          do. This is the point of Poshmark's guideline. They don't want anyone to have an unfair advantage over other
          sellers. However, using a bot that's ethically compliant with the platform's limits is not a bad thing to do.{' '}
        </p>
        <p>
          The share limit of Poshmark is 10,000 per day. However, note that someone can't share this much manually in a
          day or else, it may get you into Share jail. Instead, to safely share in the platform without getting
          compromised, sharing under 5,000 is ideal.{' '}
        </p>
        <p>
          Another task that can put your closet at risk is the Follows. Following as many poshers as you want is okay,
          but you have to note that even this task has limits. You can avoid getting in the Follow Jail if you follow
          under the threshold of 7000 per day. In addition to this, note that there is a 1000 limit when following from
          someone's following list.
        </p>
        <p>
          It always pays to be knowledgeable about the dos and don'ts of the marketplace that you are selling into.
          While always playing safe in real life is disagreeable, that is not the case on Poshmark. Keeping your closet
          safe and far from any troubles is what will help you grow your business. This is why, if you want to use an
          automation bot in your Posh account, always go for a service that ensures your business' safety while reaching
          a broader audience.
        </p>

        <h3>OneShop: Your Partner to Success</h3>
        <p>
          Selling online can be a dreadful venture, especially when you have a lot of listings. Ensuring that your
          closet is active and reaching as many potential buyers as possible is a tough job when you are doing
          everything manually.{' '}
        </p>
        <p>
          Having a bot to help you automate tasks in your closet can be tricky. You have to ensure that your automation
          software performs similar to human-like behavior to avoid getting your closet and Posh account at risk. That
          is why we have created OneShop.
        </p>
        <p>
          OneShop is an intelligent software that acts human-like to ensure that your closet is safe while reaching many
          poshers. It can perform tasks such as shares, follows, follow back, relist, delist, solve CAPTCHAs, and many
          more that help thousands of sellers boost their sales without sitting in front of their devices for long
          periods.{' '}
        </p>
        <p>
          If you are also selling on other marketplaces such as Mercari and Depop, OneShop makes it easy for you to
          cross-list. All you have to do is draft once and cross-list on another platform that our system has
          integrated.{' '}
        </p>
        <p>
          With an effective bot like OneShop, you can save tons of hours and effort in growing your sales. You can
          comfortably leave your closet and do either important things such as managing inventory, shipping out
          packages, and having time for your personal life without compromising the activity of your closet.
        </p>
        <p>
          OneShop offers a 7-day free trial should you want to try how it can level up your Poshmark game. We have a
          customer support team that can help you anytime, and we also have competitive pricing should you decide to
          subscribe. All you have to do is sign up <a href='https://tools.oneshop.com/signup'>here</a>, and we will send
          you the link to the app.{' '}
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
